import React from 'react'
import AvailabilityMessage from '../../AvailabilityMessage/AvailabilityMessage'

export const DeliveryAvailability = ({ showDeliveryForm, deliveryIcon, deliveryMessage, deliveryPostcode }) => {
  const options = {
    icon: deliveryIcon,
    message: deliveryMessage ? deliveryMessage.replace(deliveryPostcode, `<strong>${deliveryPostcode}</strong>`) : ''
  }
  return !showDeliveryForm && <AvailabilityMessage {...options} />
}
